<template>
  <ranking-main>
    <ranking-header activeMenu="Dividend" slot="rankingNavigation" />
    <loading-container :loading="form.rankLoading">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-7">
            <div>{{ $t('dividend.ranking_intro')}}</div>
          </div>
          <div class="col-md-5">
            <loading-container :loading="form.rankSectorLoading">
              <el-select
                class="w-100"
                v-model="searchSector"
                clearable 
                :placeholder="$t('sector_types.title')"
                @change="gotoFilter()">
                <el-option
                  v-for="item in filterOptions"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                  <span>{{ item.text }}</span>
                  <span class="right-align">
                    <i :class="getSectorIcons(`${item.value}`)"></i> 
                  </span>
                </el-option>
              </el-select>
            </loading-container>
            <el-select
                class="mt-2 w-100"
                v-model="searchType"
                clearable 
                :placeholder="$t('business_types.title')"
                @change="gotoFilter()">
                <el-option
                  v-for="item in filterBusinessTypeOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                  <span>{{ item.name }}</span>
                  <span class="right-align">
                    <i :class="getTypeIcons(`${item.code}`)"></i> 
                  </span>
                </el-option>
            </el-select>
            <div class="mt-2">
              <custom-checkbox id="bCheckbox" 
                :label="$t('indicators.buffett') + ' (' + displayPercentage(`${bIndicator}`) + ')'" 
                :value="isYardstick" 
                @change="gotoFilter">
              </custom-checkbox>
            </div>
          </div>
        </div>
        
      </div>
      <loading-container :loading="form.rankFilterLoading">
        <div v-if="rank.length > 0" class="padding-2">
          <div v-for="(item, index) in rank"
              :class="index % 2 == 0 ? 'odd' : 'even'"
              :key="item.code">
            <h5 class="m-t-20">
              <span class="badge bg-danger ms-auto mr-2">{{ index + 1 }}</span>
              <a
                class="d-inline waves-effect"
                @click="() => linkToStockInfo(item.code, false)"
              >
                <span>{{ item.code }} - </span>
              </a>
              <span class="font-12" v-if="item.type">
                <IconTooltip :iconClass="getTypeIcons(`${item.type}`)" :text="getBusinessTypeText(`${item.type}`)"/>
              </span>
              <span class="font-12">
                | <IconTooltip :iconClass="getSectorIcons(`${item.sector_code}`)" :text="getSectorText(`${item.sector_code}`)"/>
                | {{ item.industry }}
              </span>
              <span class="font-12" v-if="item.vn30"> - <span class="text-warning bg-danger">VN30</span></span>
              <span v-if="item.mos_rating === 'GREAT'">
                <IconTooltip iconClass="text-purple fa fa-star" :text="$t('ranking.great_mos')"/>
              </span>
              <span v-if="item.mos_rating === 'GOOD'">
                <IconTooltip iconClass="text-green fa fa-star" :text="$t('ranking.good_mos')"/>
              </span>
              <span v-if="item.mos_rating === 'FAIR'">
                <IconTooltip iconClass="text-yellow fa fa-star" :text="$t('ranking.fair_mos')"/>
              </span>
              <span v-if="item.warning">
                <IconTooltip iconClass="text-danger fas fa-exclamation-triangle" :text="$t('messages.warning_state')"/>
              </span>
              <a
                class="d-inline waves-effect waves-dark right-align text-blue"
                @click="() => linkToStockInfo(item.code, true)"
              >
                <i class="mdi mdi-launch"></i>
              </a>
            </h5>
            <div class="row">
              <div class="col-md-7">
                <div class="progress">
                  <div class="progress-bar active progress-bar-striped"
                    :class="['bg-success']"
                    role="progressbar"
                    :style="{ width: mosValueFilter(item.value * 10)}"> 
                    {{ mosValueFilter(item.value * 10) }} 
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row m-t-20 m-l-10">
          {{ $t('messages.filter_no_result') }}
        </div>
      </loading-container>
    </loading-container>
  </ranking-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LoadingContainer from '@/components/Misc/LoadingContainer';
import RankingHeader from '../components/Header';
import RankingMain from '../components/Main';
import InputSelect from "@/components/Form/InputSelect";
import CustomCheckbox from '@/components/Common/CustomCheckbox';
import common from "@/libs/common";
import helper from "@/libs/helper";
import IconTooltip from '../../../components/Common/IconTooltip.vue';

export default {
  name: 'RankDca',
  components: {
    LoadingContainer,
    IconTooltip,
    RankingHeader,
    RankingMain,
    InputSelect,
    CustomCheckbox
  },
  beforeMount() {
    this.getRankingByType({type: 4, params: {}});
    this.getBIndicator();
    if (!this.sectors.length) {
      this.getRankingSectors();
    };
  },
  data() {
    return {
      searchSector: '',
      searchType: '',
      isYardstick: false
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      form: "ranking/form",
      rank: "ranking/rank",
      search: "ranking/search",
      sectors: "ranking/sectors",
      bIndicator: "common/bIndicator"
    }),
    filterOptions() {
      return this.sectors;
    },
    filterBusinessTypeOptions() {
      return common.getTypeOptions();
    },
    routeName() {
      return this.$router.name;
    },
    currentPage() {
      return this.$store.state.route.meta.title;
    },
    currentUser() {
      return this.user || {};
    },
  },
  methods: {
    ...mapActions({
      setDefaultCode: "configuration/setDefaultCode",
      getRanking: "ranking/getRanking",
      getRankingByType: "ranking/getRankingByType",
      getRankingSectors: "ranking/getSectors",
      getBIndicator: "common/getBIndicator"
    }),
    getTypeIcons(code) {
      return common.getTypeIcons(code);
    },
    getSectorIcons(code) {
      return common.getSectorIcons(code);
    },
    getSectorText(code) {
      return common.getSectorText(code);
    },
    getBusinessTypeText(code) {
      return common.getBusinessTypeText(code);
    },
    displayPercentage(value) {
      return helper.percentDisplay(value, 'N/A');
    },
    getSectorIcons(iconCode) {
      return common.getSectorIcons(iconCode);
    },
    getTypeIcons(iconCode) {
      return common.getTypeIcons(iconCode);
    },
    mosValueFilter(value) {
      return _.round(value * 10, 1) + '%';
    },
    linkToStockInfo(code, isNewtab) {
      this.setDefaultCode(code);
      
      if(isNewtab) {
        let routeData = this.$router.resolve({name: 'overview', params: { codeId: code } });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push({ name: 'overview', params: { codeId: code } }).catch(()=>{});
      }
    },
    gotoFilter(isChecked) {
      const filter = {};
      if (this.searchSector) {
        filter['sectors'] = [this.searchSector]
      }
      if (this.searchType) {
        filter['types'] = [this.searchType]
      }
      if (isChecked == true) {
        this.isYardstick = isChecked;
      } else if (isChecked == false) {
        this.isYardstick = false;
      }
      filter['yardstick'] = this.isYardstick
      this.getRankingByType({type: 4, params: filter});
    },
  },
};
</script>
<style scoped>
.progress-bar {
  color: #000;
}


</style>